module.exports = __webpack_public_path__ + "static/img/image.60bf9528.svg";